<template>
  <a-modal
    :visible="visible"
    title="下载"
    okText="确定"
    @ok="ok"
    @cancel="$emit('cancel')"
  >
    <a-spin :spinning="spinning">
      <div class="m-4" ref="wrapEl">
        <a-checkbox-group :options="downloadOptions" v-model="downloadValue" />
      </div>
    </a-spin>
  </a-modal>
</template>
<script>
import { config } from '@/api/config';
import { download, downloadUrl } from '@/utils/download';
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    visible: Boolean,
  },
  data() {
    return {
      DownloadType: {
        Content2: 1,
        Content: 2,
        Invoice: 3,
        License: 4,
        Voucher: 5,
      },
      setting: {},
      spinning: false,
      downloadValue: [],
    };
  },
  watch: {
    visible(a) {
      if (a) {
        if (
          this.info.status > 4 &&
          (this.info.file_path2 != '' || this.info.sign_file_path2 != '') &&
          this.info.status != 7
        ) {
          this.downloadValue = [this.DownloadType.Content2];
        } else {
          this.downloadValue = [];
        }
      }
    },
  },
  computed: {
    bcdls() {
      let bcdlarray = [];
      if (this.info.bcdl) {
        for (let i of this.info.bcdl) {
          if (i.receipt_file_src) {
            bcdlarray.push(i);
          }
        }
      }
      return bcdlarray;
    },
    signurl() {
      return this.info.status == 5 ||
        this.info.status == 7 ||
        this.info.status == 13
        ? {
            signurl: this.info.sign_file_path,
            signurl2: this.info.sign_file_path2,
          }
        : { signurl: this.info.file_path, signurl2: this.info.file_path2 };
    },
    downloadOptions() {
      let options = [];
      if (
        this.info.status > 4 &&
        (this.info.file_path2 != '' || this.info.sign_file_path2 != '') &&
        this.info.status != 7
      ) {
        options.push({ label: '电子保函', value: this.DownloadType.Content2 });
      }
      if (
        this.info.status > 4 &&
        (this.info.file_path != '' || this.info.sign_file_path != '') &&
        this.info.status != 7
      ) {
        options.push({ label: '电子合同', value: this.DownloadType.Content });
      }
      if (this.info.invoice) {
        options.push({ label: '电子发票', value: this.DownloadType.Invoice });
      }
      // if (this.bcdls.length > 0) {
      //   options.push({ label: '银行回单', value: this.DownloadType.Voucher });
      // }
      // if (this.setting.financing_license_src) {
      //   options.push({ label: '融资证明', value: this.DownloadType.License });
      // }
      return options;
    },
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    async getConfig() {
      this.setting = (await config()) || {};
    },
    async ok() {
      this.spinning = true;
      if (this.downloadValue.length == 0) {
        this.$message.warning('请选择下载选项');
        return;
      }
      for (let i of this.downloadValue) {
        await this.downloadFile(i);
        this.sleep(500);
      }
      this.spinning = false;
      this.$emit('cancel');
    },
    async downloadFile(type) {
      switch (type) {
        case this.DownloadType.Content:
          await download(this.info, 0);
          break;
        case this.DownloadType.Content2:
          await download(this.info, 1);
          break;
        case this.DownloadType.Invoice:
          for (let i of this.info.invoice) {
            await downloadUrl(
              this.$ossUrl + i.invoice_file_src,
              `发票-${this.info.bidder}-${this.info.prefix}${this.info.code}-${i.invoiceSerialNum}.pdf`
            );
          }
          break;
        case this.DownloadType.License:
          await downloadUrl(
            this.$ossUrl + this.setting.financing_license_src,
            `融资证照.pdf`
          );
          break;
        case this.DownloadType.Voucher:
          for (let i = 0; i < this.bcdls.length; i++) {
            await downloadUrl(
              this.$ossUrl + this.bcdls[i].receipt_file_src,
              `银行回单-${this.info.bidder}-${this.info.prefix}${this.info.code}-${i}.pdf`
            );
          }
          break;
      }
    },
    sleep(delay) {
      var start = new Date().getTime();
      while (new Date().getTime() - start < delay) {
        continue;
      }
    },
  },
};
</script>
